'use client'
import {
  useTableStyles
} from "./chunk-GEJVU65N.mjs";

// src/tbody.tsx
import { chakra, forwardRef } from "@chakra-ui/system";
import { jsx } from "react/jsx-runtime";
var Tbody = forwardRef((props, ref) => {
  const styles = useTableStyles();
  return /* @__PURE__ */ jsx(chakra.tbody, { ...props, ref, __css: styles.tbody });
});

export {
  Tbody
};
//# sourceMappingURL=chunk-J4QO5GAJ.mjs.map